import './anchor.css';

import React, { AnchorHTMLAttributes } from 'react';

export type AnchorParams = AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link: React.FC<AnchorParams> = ({ children, className, ...props }) => {
  return (
    <a className={className} {...props}>
      {children}
    </a>
  );
};
